import { mapApiCustomerToDetailView } from "../../../../../utils/customerMappers";

export function buildCustomerDetailView(customer) {
  return mapApiCustomerToDetailView(customer);
}
